// 將 datetimeFormatter 輸出轉換為 datetime-local 格式
export default function formatToDateTimeLocal(datetimeString, timezone = '+8') {
    if (!datetimeString) return '';
    
    try {
        // 1. 先將 datetimeString 轉換為 Date 物件（假設輸入是 UTC 或標準格式）
        const inputDate = new Date(datetimeString);
        if (isNaN(inputDate.getTime())) {
        throw new Error('Invalid date string');
        }
        
        // 2. 處理時區偏移
        let timezoneOffset = 0;
        if (typeof timezone === 'string') {
        const match = timezone.match(/^([+-])(\d{1,2})$/);
        if (match) {
            const sign = match[1] === '+' ? 1 : -1;
            const hours = parseInt(match[2]);
            timezoneOffset = sign * hours;
        }
        } else if (typeof timezone === 'number') {
        timezoneOffset = timezone;
        }
        
        // 3. 加上時區偏移（轉換為毫秒）
        const offsetMs = timezoneOffset * 60 * 60 * 1000;
        const localDate = new Date(inputDate.getTime() + offsetMs);
        
        // 4. 格式化為 datetime-local 格式：'YYYY-MM-DDTHH:MM'
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const hours = String(localDate.getHours()).padStart(2, '0');
        const minutes = String(localDate.getMinutes()).padStart(2, '0');
        
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
        console.error('Error converting datetime format:', error);
        return '';
    }
};